<div mat-dialog-title>
    ทำแบบทดสอบสำเร็จ
    <div style="float: right; margin-top: -5px;">

        <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()"
            style="float: right; margin-top: -6px;">
            <img src="../../../../assets/close-white.png" style="width: 12px;">
        </button>
    </div>
</div>

<mat-dialog-content class="mat-typography" style="padding: 0px 3%;">
    <div class="container">
        <div class="justify-content-center">
            <img src="assets/congratulation.png" style="width: 100px;" alt="congrate" class="img-fluid img-center">
            <h5 class="lifedi-color text-center">
                คุณทำแบบทดสอบสำเร็จ
            </h5>
            <h6 class="text-center my-2">
                หากต้องการดูรายงานผลแบบทดสอบ
            </h6>
            <h6 class="text-center my-2">
                กรุณาแจ้งผู้มีส่วนร่วมให้ร่วมทำแบบทดสอบนี้
            </h6>
        </div>

        <div class="d-flex justify-content-center my-3">
            <div (click)="closeModal()" class="btn btn-outline-lifedi mx-2">กลับ</div>
            <div (click)="changeInformant()" class="btn btn-lifedi mx-2">ตรวจสอบผู้มีส่วนร่วม</div>
        </div>
    </div>
</mat-dialog-content>